import React from 'react'
import './ChemicalPeel.css'
import { RiArrowRightSLine } from 'react-icons/ri'
import Header from '../../Header/header'
import Whatsapp from '../../Whatsapp/Whatsapp'
import ServiceFAQ from '../ServiceFAQ'
import ServiceDoctorInfo from '../ServiceDoctorInfo'
import doc_img from '../../../assets/doc_img.webp'

const peelFAQs = [
  {
    question: 'Do chemical peels hurt?',
    answer: 'Most peels cause only mild tingling or warmth during application, which subsides once the peel is neutralised or removed.',
  },
  {
    question: 'How many sessions will I need?',
    answer:
      'For general glow, a single session can help, but for pigmentation or acne scars, a series of 4-6 peels spaced a few weeks apart usually gives the best results.',
  },
  {
    question: 'Is there downtime after a chemical peel?',
    answer:
      'Light flaking or peeling over the following days is normal. Most patients can resume regular activities immediately, avoiding sun exposure and harsh products.',
  },
  {
    question: 'Can chemical peels treat acne scars?',
    answer:
      'Yes, peels help improve texture and mild acne scarring by encouraging fresh skin to surface, though deeper scars may need additional treatments.',
  },
]

const ChemicalPeel = () => {
  return (
    <div className='asthmacontent'>
      <Header />
      <Whatsapp />
      <div className='asthmamain'>
        <div className='chemicalhero'>
          <div className='asthmainner'>
            <div className='heroservice'>
              Service <RiArrowRightSLine /> Chemical Peel
            </div>
            <div className='heroheadline'>
              <h1 className='' style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                Glow Starts with Healthy Skin
              </h1>
              <p className='' style={{ fontFamily: 'inherit' }}>
                Advanced chemical peel therapy to reduce acne, pigmentation, and early signs of aging.
              </p>
            </div>
            <a href='/appoint'>
              <button className='asthmabtn'>Book Now</button>
            </a>
          </div>
        </div>
        <div className='asthmamid'>
          <div className='asthmapra'>
            <div>
              <h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>Chemical Peel Treatment for Radiant Skin</h2>
              <p>
                Unlock smoother, brighter skin with our professional chemical peel therapy at Sharva Clinique. Whether you’re dealing with acne scars,
                dull complexion, fine lines, or pigmentation, our customized chemical peel treatments help restore your skin’s natural glow and
                texture.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>What Is a Chemical Peel?</h3>
              <p>
                A chemical peel is a safe, non-surgical skin treatment that uses a gentle acid solution to exfoliate the outer layers of your skin.
                This process removes dead skin cells, stimulates cellular renewal, and encourages collagen production. The result is smoother,
                fresher, more youthful-looking skin. At Sharva Clinique, we tailor every peel based on your skin type and goals.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Benefits of Chemical Peels</h3>
              <p>Our chemical peel service offers multiple skincare benefits:</p>
              <ul>
                <li>Improves texture and tone by reducing dullness and rough patches</li>
                <li>Lightens dark spots, pigmentation, and sun damage</li>
                <li>Softens fine lines and early signs of aging</li>
                <li>Reduces breakouts and acne scars</li>
                <li>Boosts overall radiance and clarity</li>
              </ul>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Personalized Treatment Plans</h3>
              <p>
                Every person’s skin is different. That’s why our experienced skin specialists begin with a detailed consultation to assess your skin
                condition and concerns. We then recommend the ideal peel strength and formulation for your needs. From mild peels for gentle
                exfoliation to deeper peels for more significant concerns, we ensure a comfortable and effective experience.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>What to Expect During the Procedure</h3>
              <p>
                The process is quick and comfortable. After cleansing your skin, the chosen chemical solution is applied for a few minutes. You may
                feel a mild tingling sensation. Once the peel is complete, a soothing moisturizer and SPF protection are applied. Most treatments take
                about 30-45 minutes, and you can usually return to your daily routine shortly after.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Post-Treatment Care</h3>
              <p>
                To get the best results, protect your skin with broad-spectrum sunscreen and follow the aftercare advice given by our specialists. You
                may experience slight peeling or redness, which is a normal part of the renewal process.
              </p>
            </div>

            <ServiceDoctorInfo
              name='Dr. Sweta Mishra'
              specialty='Maxillofacial Aesthetic Surgeon'
              education='MDS, FAM, Dip. in Aesthetic Medicine'
              image={doc_img}
              blurb='Dr. Sweta Mishra customises chemical peel treatments at Sharva Clinique to target pigmentation, acne, and dull skin safely and effectively.'
              profileLink='/drSweta/peels'
            />

            <ServiceFAQ title='FAQs - Chemical Peel Treatment' faqs={peelFAQs} />
          </div>
          <div className='asthmareview'>
            <p
              className=''
              style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#85553D',
                fontFamily: 'inherit',
              }}
            >
              What Our Patients Say
            </p>
            <div className='card1'>
              <p>"Gentle yet effective. I saw reduced acne scars and improved texture within a few days. Friendly staff and great care.”</p>
              <p> — Rohan </p>
            </div>
            <div className='card2'>
              <p>“Professional service and excellent results. My friends are already asking what I did for my glowing skin!”</p>
              <p> — Sneha </p>
            </div>
            <div className='card3'>
              <p>“My skin feels fresh and smooth.”</p>
              <p> — Ritika</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChemicalPeel
